module.exports = __webpack_public_path__ + "static/img/COC2023-34.3e5f11c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting2023/COC2023-34.png
// module id = Ge10
// module chunks = 0